import React from 'react';
import { CheckIcon, GiftIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { CtaBlock } from './CtaBlock';
import { bonuses } from '../data/content';
export function Bonuses() {
  return <section className="bg-white py-14 sm:py-20" data-id="element-51" data-mp="aua7ogisxnum">
      <div className="mx-auto w-full max-w-5xl px-4 sm:px-6" data-id="element-52" data-mp="fu6d8k75dnca">
        <SectionHeading eyebrow="Ma non finisce qui…" title="Il tuo accesso include anche 5 bonus clinici pratici" subtitle="Perché avere la conoscenza è solo una parte dell’equazione. Il vero vantaggio arriva quando riesci ad applicarla rapidamente davanti a un paziente reale: imparare → applicare → consultare." data-id="element-53" data-mp="fsliatgx82dw" />

        <div className="mt-10 space-y-5" data-id="element-54" data-mp="3t06gsugceb9h">
          {bonuses.map(bonus => <article key={bonus.index} className="-mx-4 overflow-hidden border-y-2 border-gold-500/40 bg-white shadow-[0_16px_40px_-30px_rgba(7,20,41,0.8)] sm:mx-0 sm:rounded-2xl sm:border-2" data-id="element-55" data-mp="1ma8kmvh3ou14">
              <div className="flex flex-wrap items-center gap-2 border-b border-gold-500/25 bg-gold-50 px-4 py-3 sm:px-5" data-id="element-56" data-mp="3idel6385ly3t">
                <span className="flex items-center gap-1.5 rounded-full bg-navy-900 px-3 py-1 text-[10px] font-black uppercase tracking-[0.16em] text-gold-300" data-id="element-57" data-mp="3dettis6ywmqz">
                  <GiftIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-58" data-mp="3n4wlqq69lwo9" />
                  {bonus.index}
                </span>
                <span className="text-[11px] font-bold uppercase tracking-wide text-navy-900/50 line-through" data-id="element-59" data-mp="2zgdgkjiii00e">
                  Valore: {bonus.value}
                </span>
                <span className="ml-auto rounded-full bg-green-600 px-3 py-1 text-[10px] font-black uppercase tracking-[0.12em] text-white" data-id="element-60" data-mp="38gil8lwbmkav">
                  Oggi gratis
                </span>
              </div>

              <div className="w-full bg-navy-50" data-id="element-61" data-mp="nozw8jlspw5f">
                <img src={bonus.image} alt={bonus.imageAlt} className="block w-full" width={1256} height={1256} loading="lazy" data-id="element-62" data-mp="iqyh29rhqgz8" />
              </div>

              <div className="px-4 py-5 sm:px-6" data-id="element-63" data-mp="3hg6enzsufl4c">
                <h3 className="text-[17px] font-black uppercase leading-tight tracking-tight text-navy-900 sm:text-xl" data-id="element-64" data-mp="3lj33i88z8dgq">
                  {bonus.title}
                </h3>
                <p className="mt-1.5 text-[13px] font-extrabold uppercase tracking-wide text-gold-700" data-id="element-65" data-mp="2tsf1ktzhb420">
                  {bonus.subtitle}
                </p>
                <p className="mt-3 text-[14px] leading-relaxed text-navy-900/70 sm:text-[15px]" data-id="element-66" data-mp="2xujsvm2gfolh">
                  {bonus.text}
                </p>

                <p className="mt-5 text-[10px] font-black uppercase tracking-[0.18em] text-navy-900/45" data-id="element-67" data-mp="37jjtf9wlus1s">
                  {bonus.listLabel}
                </p>
                <ul className="mt-3 grid gap-2 sm:grid-cols-2" data-id="element-68" data-mp="2a45yvq0b7fo9">
                  {bonus.items.map(item => <li key={item} className="flex items-start gap-2 text-[14px] font-medium leading-snug text-navy-900" data-id="element-69" data-mp="2f1fuxoi7epl2">
                      <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-gold-600" aria-hidden="true" data-id="element-70" data-mp="22lpwmyuoc8hv" />
                      {item}
                    </li>)}
                </ul>
              </div>
            </article>)}
        </div>

        <div className="mt-10 flex justify-center" data-id="element-71" data-mp="1jup2co4i114n">
          <CtaBlock label="Ottieni tutti e 5 i bonus gratis" note="Inclusi oggi con il tuo accesso da 19 EUR" data-id="element-72" data-mp="1jsuhf9t8990k" />
        </div>
      </div>
    </section>;
}